import React from "react";

const CoreContext = React.createContext({
    screen: null,
    onBlockMount: () => {},
    onTeaserClick: () => {},
    sid: null,
    rcid: null,
    fpr: null,
    fprVersion: null
});

export default CoreContext;
